export default {
  welcome: 'Welcome',
  subtitle: "Take a look at what's been happening while you were gone",
  recentModelsTitle: 'My Recently Accessed Models',
  recentModelsLoading: 'Loading your recent models...',
  recentModelsEmptyTitle: 'No models accessed yet',
  recentModelsEmptyMessage: 'Models will appear here as you access them',
  createdModelsTitle: 'Recently Created Models',
  createdModelsLoading: 'Loading recent models...',
  createdModelsEmptyTitle: 'No models created yet',
  createdModelsEmptyMessage: 'Models will appear here as they are created',
  onlyMyModels: 'Only show models created by me',
  recentPlansTitle: 'Recently Created Plans',
  recentPlansLoading: 'Loading recent plans...',
  recentPlansEmptyTitle: 'No plans created yet',
  recentPlansEmptyMessage: 'Plans from your accessible models will appear here',
  onlyMyPlans: 'Only show plans created by me',
  processing: 'Processing',
  recentEkrmsTitle: 'Recently Created EKRMs',
  recentEkrmsLoading: 'Loading recent EKRMs...',
  recentEkrmsEmptyTitle: 'No EKRMs created yet',
  recentEkrmsEmptyMessage: 'EKRMs will appear here as they are created',
  onlyMyEkrms: 'Only show EKRMs created by me',
  dataUploadTitle: 'Data Upload Activity',
  dataUploadLoading: 'Loading recent uploads...',
  dataUploadEmptyTitle: 'No uploads yet',
  dataUploadEmptyMessage: 'Uploads will appear here as they are created',
  onlyMyUploads: 'Only show uploads by me',
  dataBrief: 'Data Brief',
  dataTemplate: 'Data Template',
  pendingApproval: 'Pending Approval',
  approved: 'Approved',
  modelProcessTitle: 'Model Process Activity',
  modelProcessLoading: 'Loading recent stage activity...',
  modelProcessEmptyTitle: 'No stage activity yet',
  modelProcessEmptyMessage: 'Stage activities will appear here as they occur',
  onlyMyActivities: 'Only show activities by me',
  unknown: 'Unknown',
  modelTypeAdHoc: 'Ad-Hoc',
  modelTypeCustomStandard: 'Custom Standard',
  modelTypeCustomEkrm: 'Custom EKRM',
  uploaded: 'Uploaded',
  activityApproved: 'Approved',
  activityReversed: 'Reversed',
  activityUploaded: 'Uploaded',
  activityFeedback: 'Feedback',
  activityFeedbackReply: 'Replied to feedback'
}
